import { render, staticRenderFns } from "./configField.vue?vue&type=template&id=09c4e709&scoped=true"
import script from "./configField.vue?vue&type=script&lang=js"
export * from "./configField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c4e709",
  null
  
)

export default component.exports